export type SalesOrderStatus =
  | 'DRAFT'
  | 'DRAFT_CUSTOMER'
  | 'PENDING'
  | 'SUBMITTED'
  | 'APPROVED'
  | 'PICKING'
  | 'SHIPPED'
  | 'CLOSED'
  | 'CANCELLED'
  | 'ERROR';

type GroupTypes =
  | 'all'
  | 'toSubmitted'
  | 'toPicking'
  | 'toShipped'
  | 'toClosed'
  | 'picking'
  | 'active'
  | 'irreversible'
  | 'toSubmittedOrCancelled'
  | 'submittedOrPicking'
  | 'draft'
  | 'shipped'
  | 'reservationReleased';

const Groups: Record<GroupTypes, SalesOrderStatus[]> = {
  all: [
    'DRAFT',
    'DRAFT_CUSTOMER',
    'PENDING',
    'SUBMITTED',
    'APPROVED',
    'PICKING',
    'SHIPPED',
    'CLOSED',
    'CANCELLED',
    'ERROR',
  ],
  draft: ['DRAFT', 'DRAFT_CUSTOMER'],
  submittedOrPicking: ['SUBMITTED', 'APPROVED', 'PICKING'],
  picking: ['PICKING'],
  shipped: ['SHIPPED', 'CLOSED'],
  // A lot reservation stops holding inventory once its order reaches one of these: ship
  // decrements `lot.quantity` (lineItems.shipping.ts) and cancel abandons the pick.
  reservationReleased: ['SHIPPED', 'CLOSED', 'CANCELLED'],

  toSubmittedOrCancelled: ['DRAFT', 'DRAFT_CUSTOMER', 'PENDING', 'APPROVED', 'SUBMITTED', 'CANCELLED'],
  toSubmitted: ['DRAFT', 'DRAFT_CUSTOMER', 'APPROVED', 'SUBMITTED'],
  toPicking: ['DRAFT', 'DRAFT_CUSTOMER', 'PENDING', 'SUBMITTED', 'APPROVED', 'PICKING'],
  toShipped: ['DRAFT', 'DRAFT_CUSTOMER', 'PENDING', 'SUBMITTED', 'APPROVED', 'PICKING', 'SHIPPED'],
  toClosed: ['DRAFT', 'DRAFT_CUSTOMER', 'PENDING', 'SUBMITTED', 'APPROVED', 'PICKING', 'SHIPPED', 'CLOSED'],

  active: ['APPROVED', 'SUBMITTED', 'PICKING', 'SHIPPED'],
  irreversible: ['CANCELLED', 'DRAFT'],
};

export default { Groups };
